import { createContext, useContext } from "react";
import type { AdminRole } from "@podecontratar/shared/lib/admin-permissions";

/**
 * The resolved role for the signed-in operator.
 *
 * AuthGate has already refused anyone without a role by the time this
 * provider mounts, so consumers can rely on a non-null value and the
 * default below is only a programming-error guard.
 */
const AdminRoleContext = createContext<AdminRole | null>(null);

export function AdminRoleProvider({
  role,
  children,
}: {
  role: AdminRole;
  children: React.ReactNode;
}) {
  return <AdminRoleContext.Provider value={role}>{children}</AdminRoleContext.Provider>;
}

export function useAdminRole(): AdminRole {
  const role = useContext(AdminRoleContext);
  if (!role) {
    throw new Error("useAdminRole must be used inside AdminRoleProvider");
  }
  return role;
}
